import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4e4b012"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-customization-view" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, [
  /*#__PURE__*/_createTextVNode("My Organization"),
  /*#__PURE__*/_createElementVNode("span", null, " » Customization")
], -1))
const _hoisted_4 = { class: "d-flex flex-column flex-sm-row text-end" }
const _hoisted_5 = { class: "me-sm-2 mb-2 mb-sm-0" }
const _hoisted_6 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_7 = { class: "dt-container dt-container--tabbed" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Customize the Ditto Connect webpage to match your organization's branding. Upload a logo and background image. Provide a custom message containing Ditto connection instructions or organizational information. ")
], -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "callout"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "PREVIEW"),
  /*#__PURE__*/_createTextVNode(":")
], -1))
const _hoisted_15 = ["href"]
const _hoisted_16 = ["d"]
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Specify your custom domain or subdomain URL here. You can set up a custom domain or subdomain to point or redirect to your branded Ditto Connect Page. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.airsquirrels.com/ditto/346-customize-the-connection-page-url",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link"
  }, "Click here to learn more.")
], -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Recommended minimum logo width is "),
  /*#__PURE__*/_createElementVNode("strong", null, "400px"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("em", null, "(3mb size limit)")
], -1))
const _hoisted_22 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Recommended minimum width for background is "),
  /*#__PURE__*/_createElementVNode("strong", null, "2400px"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("em", null, "(3mb size limit)")
], -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Insert connection instructions or other messaging here. ", -1))
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Assign colors to match your branding. ", -1))
const _hoisted_29 = {
  key: 0,
  class: "dt-color-picker"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Background Color", -1))
const _hoisted_31 = { class: "dt-color-picker mt-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Text Color", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Customize the Ditto Connect apps to match your organization's branding. ")
], -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Uploading a banner customizes the end-user experience on Windows and macOS. We recommend an image size of "),
  /*#__PURE__*/_createElementVNode("strong", null, "950px x 165px"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("em", null, "(3mb size limit)")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Customize the Ditto Receiver apps to match your organization's branding. Upload a logo and background image and adjust text colors. ")
], -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Recommended minimum logo width is "),
  /*#__PURE__*/_createElementVNode("strong", null, "400px"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("em", null, "(3mb size limit)")
], -1))
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Recommended minimum width for background is "),
  /*#__PURE__*/_createElementVNode("strong", null, "2400px"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("em", null, "(3mb size limit)")
], -1))
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Assign colors to match your branding. ", -1))
const _hoisted_46 = { class: "dt-color-picker" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Background Color", -1))
const _hoisted_48 = { class: "dt-color-picker mt-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Text Color", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Mirroring & Signage Settings", -1))
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enable Native Resolution", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enable sending native resolution of Windows and Mac devices to the receiver.", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "If this setting is disabled, all devices are scaled down to 1920x1080 pixels. Enabling or disabling this setting at the organization level will update the setting for all rooms by default. This setting can be overridden at the room level.", -1))
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Always Show Date and Time on Signage", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Date and time will be visible when signage is displayed. Enabling or disabling these settings at the organization level will update the settings for all rooms by default. These settings can be overridden at the room level.", -1))
const _hoisted_58 = { class: "row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Low-Profile Mode (Ditto Windows Receiver only)", -1))
const _hoisted_60 = { class: "d-flex" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Keep the Ditto room code visible in a small window when the receiver app is minimized.", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select “Launch” to make low-profile mode a default setting. Launch overrides the “Display Fullscreen” option located in receiver settings.", -1))
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "IP Access", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limit IP Access", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Restrict Ditto Account Portal access to specific IP addresses to prevent users from logging in outside of a desired network.", -1))
const _hoisted_67 = {
  key: 0,
  class: "row"
}
const _hoisted_68 = { class: "d-flex" }
const _hoisted_69 = {
  key: 1,
  class: "row row--table-row"
}
const _hoisted_70 = { class: "d-flex" }
const _hoisted_71 = { class: "d-flex" }
const _hoisted_72 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_73 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("Undo Changes")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            disabled: _ctx.saving,
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save Customization")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    (_ctx.showTierCallout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: "Upgrade your Ditto account to unlock more features."
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Connect Page",
            name: "connectPage"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-position": "top",
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_form_item, { label: "Connect Page URL" }, {
                        default: _withCtx(() => [
                          (!_ctx.connectPageUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                disabled: _ctx.saving,
                                class: "gen-link",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.generateConnectPageUrl && _ctx.generateConnectPageUrl(...args)), ["stop"]))
                              }, "Generate You Connect Page URL", 8, _hoisted_11))
                            : _createCommentVNode("", true),
                          (_ctx.connectPageUrl)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "This Ditto Connect Page URL displays your branding and messaging preferences."))
                            : _createCommentVNode("", true),
                          (_ctx.connectPageUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _hoisted_14,
                                _createElementVNode("a", {
                                  href: _ctx.connectPageUrl,
                                  target: "_blank",
                                  rel: "noreferrer noopener",
                                  class: "link"
                                }, _toDisplayString(_ctx.connectPageUrl), 9, _hoisted_15),
                                (_openBlock(), _createElementBlock("svg", {
                                  class: "icon m-0 ms-2",
                                  style: {"cursor":"pointer"},
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generateConnectPageUrl && _ctx.generateConnectPageUrl(...args))),
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", { d: _ctx.mdiRefresh }, null, 8, _hoisted_16)
                                ]))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_form_item, { label: "Custom Domain" }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.branding.customDomainURL,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.branding.customDomainURL) = $event)),
                            placeholder: "https://dittoconnect.mycompany.com"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_el_divider),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_form_item, { label: "Logo" }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _createVNode(_component_DigitalAssetUpload, {
                            assetUrl: _ctx.branding.logo ? _ctx.branding.logo : 'images/dittoConnectLogo.png',
                            allowVideo: false,
                            sizeLimitMB: "300",
                            onFileUploadTrigger: _cache[3] || (_cache[3] = ($event: any) => (_ctx.connectLogoUpload = $event)),
                            ref: "connectLogoUpload"
                          }, null, 8, ["assetUrl"])
                        ]),
                        _: 1
                      })
                    ]),
                    (!_ctx.useBackgroundColorConnectPage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_el_form_item, { label: "Background Image" }, {
                            default: _withCtx(() => [
                              _hoisted_23,
                              _createVNode(_component_DigitalAssetUpload, {
                                assetUrl: _ctx.branding.backgroundImage ? _ctx.branding.backgroundImage : 'images/dittoConnectBackground.png',
                                allowVideo: false,
                                sizeLimitMB: "300",
                                onFileUploadTrigger: _cache[4] || (_cache[4] = ($event: any) => (_ctx.connectBackgroundUpload = $event)),
                                ref: "connectBackgroundUpload"
                              }, null, 8, ["assetUrl"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_el_form_item, { label: "Custom Message" }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: _ctx.branding.customMessage,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.branding.customMessage) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_el_form_item, { label: "Theme Colors" }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _createElementVNode("span", null, [
                            _createVNode(_component_el_switch, {
                              modelValue: _ctx.useBackgroundColorConnectPage,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.useBackgroundColorConnectPage) = $event)),
                              onChange: _ctx.onConnectPageUseBackgroundColorChange
                            }, null, 8, ["modelValue", "onChange"]),
                            _createTextVNode(" Use background color")
                          ]),
                          (_ctx.useBackgroundColorConnectPage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createVNode(_component_el_color_picker, {
                                  modelValue: _ctx.branding.backgroundColor,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.branding.backgroundColor) = $event)),
                                  onChange: _ctx.colorPickerChange,
                                  disabled: !_ctx.useBackgroundColorConnectPage
                                }, null, 8, ["modelValue", "onChange", "disabled"]),
                                _hoisted_30
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_el_color_picker, {
                              modelValue: _ctx.branding.textColor,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.branding.textColor) = $event)),
                              onChange: _ctx.colorPickerChange
                            }, null, 8, ["modelValue", "onChange"]),
                            _hoisted_32
                          ]),
                          _createVNode(_component_el_divider),
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: _withModifiers(_ctx.resetConnectPageBranding, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Use Default Connection Page Styles")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Ditto Connect",
            name: "dittoConnect"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-position": "top",
                onSubmit: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_el_form_item, { label: "App Banner" }, {
                        default: _withCtx(() => [
                          _hoisted_36,
                          _createVNode(_component_DigitalAssetUpload, {
                            class: "app-banner-uploader",
                            assetUrl: _ctx.brandingSender.banner ? _ctx.brandingSender.banner : 'images/dittoSenderBanner.png',
                            allowVideo: false,
                            sizeLimitMB: "300",
                            onFileUploadTrigger: _cache[10] || (_cache[10] = ($event: any) => (_ctx.appBannerUpload = $event)),
                            ref: "appBannerUpload"
                          }, null, 8, ["assetUrl"]),
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: _withModifiers(_ctx.resetConnectBranding, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Use Default App Banner")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Ditto Receiver",
            name: "dittoReceiver"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-position": "top",
                onSubmit: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_el_form_item, { label: "Logo" }, {
                        default: _withCtx(() => [
                          _hoisted_40,
                          _createVNode(_component_DigitalAssetUpload, {
                            assetUrl: _ctx.brandingReceiver.logo ? _ctx.brandingReceiver.logo : 'images/dittoConnectLogo.png',
                            allowVideo: false,
                            sizeLimitMB: "300",
                            onFileUploadTrigger: _cache[12] || (_cache[12] = ($event: any) => (_ctx.receiverLogoUpload = $event)),
                            ref: "receiverLogoUpload"
                          }, null, 8, ["assetUrl"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_el_form_item, { label: "Background Image" }, {
                        default: _withCtx(() => [
                          _hoisted_42,
                          _createVNode(_component_DigitalAssetUpload, {
                            assetUrl: _ctx.brandingReceiver.backgroundImage ? _ctx.brandingReceiver.backgroundImage : 'images/dittoConnectBackground.png',
                            allowVideo: false,
                            sizeLimitMB: "300",
                            onFileUploadTrigger: _cache[13] || (_cache[13] = ($event: any) => (_ctx.receiverBackgroundUpload = $event)),
                            ref: "receiverBackgroundUpload"
                          }, null, 8, ["assetUrl"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_el_form_item, { label: "Theme Colors" }, {
                        default: _withCtx(() => [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_el_color_picker, {
                              modelValue: _ctx.brandingReceiver.backgroundColor,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.brandingReceiver.backgroundColor) = $event)),
                              onChange: _ctx.colorPickerChange
                            }, null, 8, ["modelValue", "onChange"]),
                            _hoisted_47
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_el_color_picker, {
                              modelValue: _ctx.brandingReceiver.textColor,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.brandingReceiver.textColor) = $event)),
                              onChange: _ctx.colorPickerChange
                            }, null, 8, ["modelValue", "onChange"]),
                            _hoisted_49
                          ]),
                          _createVNode(_component_el_divider),
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: _withModifiers(_ctx.resetReceiver, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Use Default Ditto Receiver Styles")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Organization Settings",
            name: "organizationSettings"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-position": "top",
                rules: _ctx.rules,
                ref: "orgSettingsForm",
                model: _ctx.ipWhiteList,
                onSubmit: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_el_form_item, { class: "mt-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", null, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.mutatableOrg.enableHigherResolution,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mutatableOrg.enableHigherResolution) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_52
                        ]),
                        _hoisted_53,
                        _hoisted_54
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createElementVNode("label", null, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.mutatableOrg.showSignageDateTime,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mutatableOrg.showSignageDateTime) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_56
                        ]),
                        _hoisted_57,
                        (_ctx.mutatableOrg.showSignageDateTime)
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 0,
                              modelValue: _ctx.mutatableOrg.signageDateTimeLocation,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.mutatableOrg.signageDateTimeLocation) = $event)),
                              class: "select--small"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Top Left",
                                  value: "topLeft"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Top Right",
                                  value: "topRight"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Bottom Left",
                                  value: "bottomLeft"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Bottom Right",
                                  value: "bottomRight"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _hoisted_61,
                          _hoisted_62,
                          _createVNode(_component_el_select, {
                            class: "select--small",
                            modelValue: _ctx.mutatableOrg.enableReceiverLowProfileMode,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.mutatableOrg.enableReceiverLowProfileMode) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Disabled",
                                value: 0
                              }),
                              _createVNode(_component_el_option, {
                                label: "Enabled",
                                value: 1
                              }),
                              _createVNode(_component_el_option, {
                                label: "Launch",
                                value: 2
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode(_component_el_form_item, { prop: "enableIpAddressWhiteList" }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", null, [
                          _createVNode(_component_el_tooltip, {
                            disabled: _ctx.allowIpAddressWhitelist,
                            effect: "dark",
                            content: "Upgrade your Ditto account to unlock this feature.",
                            placement: "bottom",
                            "hide-after": 0,
                            "show-after": 500
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                disabled: !_ctx.allowIpAddressWhitelist,
                                modelValue: _ctx.mutatableOrg.enableIpAddressWhiteList,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mutatableOrg.enableIpAddressWhiteList) = $event))
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _hoisted_65
                        ]),
                        _hoisted_66
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.mutatableOrg.enableIpAddressWhiteList)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_component_el_form_item, {
                            label: "IP Address",
                            prop: "ipAddress"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                disabled: !_ctx.allowIpAddressWhitelist,
                                modelValue: _ctx.ipWhiteList.ipAddress,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.ipWhiteList.ipAddress) = $event)),
                                placeholder: "192.168.0.1"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createTextVNode("   "),
                          _createVNode(_component_el_form_item, { label: "Description" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                disabled: !_ctx.allowIpAddressWhitelist,
                                modelValue: _ctx.ipWhiteList.description,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.ipWhiteList.description) = $event)),
                                placeholder: "World Headquarters"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createTextVNode("   "),
                          _createVNode(_component_el_button, {
                            disabled: !_ctx.allowIpAddressWhitelist,
                            type: "text",
                            onClick: _withModifiers(_ctx.addIPAddress, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("+ Add IP Address")
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.mutatableOrg.enableIpAddressWhiteList)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        (_ctx.mutatableOrg.ipAddressWhiteList)
                          ? (_openBlock(), _createBlock(_component_el_table, {
                              key: 0,
                              data: _ctx.mutatableOrg.ipAddressWhiteList,
                              "empty-text": "No IP Addresses"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  prop: "ipAddress",
                                  label: "IP Address",
                                  sortable: ""
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_70, [
                                      _createElementVNode("span", null, _toDisplayString(scope.row.ipAddress), 1)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "description",
                                  label: "Description",
                                  sortable: ""
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("span", null, _toDisplayString(scope.row.description), 1)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "ipAddress",
                                  "class-name": "el-table-row__delete"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_el_button, {
                                      class: "el-table-row__delete-button",
                                      type: "danger",
                                      id: scope.row.ipAddress,
                                      onClick: ($event: any) => (_ctx.removeIPAddress(scope.row.ipAddress)),
                                      circle: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock("svg", _hoisted_72, [
                                          _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_73)
                                        ]))
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ])), [
    [_directive_loading, _ctx.viewLoading]
  ])
}